/**
 * Business Unit + Site (2 layers only).
 * Both link to Village Master via villageId.
 *
 * BU Master fields + Site Master fields from product sheet.
 */

export const businessUnitSeed = [
  {
    buId: 'BU-APMUL',
    shortName: 'APMuL',
    fullNameGst: 'Adani Power Mundra Limited',
    address1: 'Mundra Power Plant Complex',
    address2: '',
    villageId: 'V-MUN-059', // Mundra
    active: true,
  },
  {
    buId: 'BU-MSTPL',
    shortName: 'MSTPL (EMC)',
    fullNameGst: 'Mundra Solar Technologies Private Limited',
    address1: 'EMC Zone',
    address2: '',
    villageId: 'V-MUN-002', // Tunda
    active: true,
  },
  {
    buId: 'BU-KCL',
    shortName: 'KCL',
    fullNameGst: 'Kutch Copper Limited',
    address1: '',
    address2: '',
    villageId: 'V-MUN-001', // Baroi
    active: true,
  },
  {
    buId: 'BU-AWL',
    shortName: 'AWL',
    fullNameGst: 'Adani Wilmar Limited',
    address1: '',
    address2: '',
    villageId: 'V-MUN-011', // Navinal
    active: true,
  },
  {
    buId: 'BU-MPL',
    shortName: 'MPL',
    fullNameGst: 'Mundra Petrochemicals Limited',
    address1: '',
    address2: '',
    villageId: 'V-MUN-004', // Nana Kapaya
    active: true,
  },
  {
    buId: 'BU-PORT',
    shortName: 'Port',
    fullNameGst: 'Adani Ports and SEZ Limited',
    address1: 'Mundra Port',
    address2: '',
    villageId: 'V-MUN-001', // Baroi
    active: true,
  },
  {
    buId: 'BU-CEM',
    shortName: 'Cement',
    fullNameGst: 'Adani Cement Works',
    address1: '',
    address2: '',
    villageId: 'V-MUN-007', // Bhadresar
    active: true,
  },
  {
    buId: 'BU-AIIL',
    shortName: 'AIIL (Howe)',
    fullNameGst: 'Adani Infrastructure India Limited',
    address1: '',
    address2: '',
    villageId: 'V-MUN-010', // Dhrab
    active: true,
  },
  {
    buId: 'BU-RLY',
    shortName: 'Railway',
    fullNameGst: 'Mundra Rail Corridor',
    address1: '',
    address2: '',
    villageId: 'V-MUN-012', // Mota Kapaya
    active: true,
  },
  {
    buId: 'BU-AF',
    shortName: 'Adani Foundation',
    fullNameGst: 'Adani Foundation',
    address1: '',
    address2: '',
    villageId: 'V-MUN-059',
    active: true,
  },
];

export const siteSeed = [
  // APMuL sites (flattened from old groups)
  { siteId: 'ST-MSPVL', buId: 'BU-APMUL', siteName: 'MSPVL', projectOperation: 'Solar Cell / Module', address1: '', address2: '', villageId: 'V-MUN-002', active: true },
  { siteId: 'ST-MSEL', buId: 'BU-APMUL', siteName: 'MSEL', projectOperation: 'Solar Manufacturing', address1: '', address2: '', villageId: 'V-MUN-002', active: true },
  { siteId: 'ST-MWL', buId: 'BU-APMUL', siteName: 'MWL', projectOperation: 'N&H / RBU', address1: '', address2: '', villageId: 'V-MUN-011', active: true },
  { siteId: 'ST-MSTL', buId: 'BU-APMUL', siteName: 'MSTL', projectOperation: 'Ingot / Wafer', address1: '', address2: '', villageId: 'V-MUN-002', active: true },
  { siteId: 'ST-JASH', buId: 'BU-APMUL', siteName: 'Jash Energy', projectOperation: 'Energy', address1: '', address2: '', villageId: 'V-MUN-003', active: true },

  // MSTPL / Vishakha sites
  { siteId: 'ST-VRPL', buId: 'BU-MSTPL', siteName: 'VRPL', projectOperation: 'Vishakha', address1: '', address2: '', villageId: 'V-MUN-004', active: true },
  { siteId: 'ST-VFSPL', buId: 'BU-MSTPL', siteName: 'VFSPL', projectOperation: 'Vishakha', address1: '', address2: '', villageId: 'V-MUN-004', active: true },
  { siteId: 'ST-VMPL', buId: 'BU-MSTPL', siteName: 'VMPL', projectOperation: 'Vishakha', address1: '', address2: '', villageId: 'V-MUN-005', active: true },
  { siteId: 'ST-VGPL', buId: 'BU-MSTPL', siteName: 'VGPL', projectOperation: 'Vishakha', address1: '', address2: '', villageId: 'V-MUN-005', active: true },

  // MPL pockets
  { siteId: 'ST-MPL-P1', buId: 'BU-MPL', siteName: 'Pocket - 1', projectOperation: 'Operations', address1: '', address2: '', villageId: 'V-MUN-004', active: true },
  { siteId: 'ST-MPL-P2', buId: 'BU-MPL', siteName: 'Pocket - 2', projectOperation: 'Operations', address1: '', address2: '', villageId: 'V-MUN-004', active: true },
  { siteId: 'ST-MPL-P3', buId: 'BU-MPL', siteName: 'Pocket - 3', projectOperation: 'Operations', address1: '', address2: '', villageId: 'V-MUN-004', active: true },
  { siteId: 'ST-MPL-P4', buId: 'BU-MPL', siteName: 'Pocket - 4 (Fabrication Shop)', projectOperation: 'Fabrication', address1: '', address2: '', villageId: 'V-MUN-004', active: true },
  { siteId: 'ST-MPL-P5', buId: 'BU-MPL', siteName: 'Pocket - 5', projectOperation: 'Operations', address1: '', address2: '', villageId: 'V-MUN-004', active: true },

  // Port
  { siteId: 'ST-CT1', buId: 'BU-PORT', siteName: 'CT-1', projectOperation: 'South Port Terminal', address1: '', address2: '', villageId: 'V-MUN-001', active: true },
  { siteId: 'ST-CT2', buId: 'BU-PORT', siteName: 'CT-2', projectOperation: 'South Port Terminal', address1: '', address2: '', villageId: 'V-MUN-001', active: true },
  { siteId: 'ST-CT3', buId: 'BU-PORT', siteName: 'CT-3', projectOperation: 'South Port Terminal', address1: '', address2: '', villageId: 'V-MUN-001', active: true },
  { siteId: 'ST-CT4', buId: 'BU-PORT', siteName: 'CT-4', projectOperation: 'South Port Terminal', address1: '', address2: '', villageId: 'V-MUN-001', active: true },
  { siteId: 'ST-CT5', buId: 'BU-PORT', siteName: 'CT-5', projectOperation: 'South Port Terminal', address1: '', address2: '', villageId: 'V-MUN-001', active: true },
  { siteId: 'ST-WPORT', buId: 'BU-PORT', siteName: 'West Port', projectOperation: 'West Port', address1: '', address2: '', villageId: 'V-MUN-010', active: true },
];

export function findBuById(bus, buId) {
  if (buId == null || buId === '') return null;
  const list = bus || businessUnitSeed;
  const key = String(buId);
  return (
    list.find((b) => String(b.buId) === key) ||
    list.find((b) => String(b.id) === key) ||
    null
  );
}

export function findSiteById(sites, siteId) {
  if (siteId == null || siteId === '') return null;
  const list = sites || siteSeed;
  const key = String(siteId);
  return (
    list.find((s) => String(s.siteId) === key) ||
    list.find((s) => String(s.id) === key) ||
    null
  );
}

export function sitesForBu(sites, buId) {
  if (!buId) return [];
  const key = String(buId);
  return (sites || siteSeed).filter((s) => {
    if (s.active === false) return false;
    return (
      String(s.buId) === key ||
      String(s.buDbId) === key ||
      (s.businessUnit?.code != null && String(s.businessUnit.code) === key)
    );
  });
}

/** True when the BU has at least one active site. */
export function hasSitesForBu(sites, buId) {
  return sitesForBu(sites, buId).length > 0;
}

/** BUs that have at least one active site (for forms that require Site). */
export function busWithSites(bus, sites) {
  return (bus || []).filter(
    (b) => hasSitesForBu(sites, b.buId) || hasSitesForBu(sites, b.id),
  );
}
